<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="loading" :can-cancel="false" :is-full-page="true" />
    <loading :active.sync="loadingCAl" :can-cancel="false" :is-full-page="true" />
    <loading :active.sync="loadingHorarios" :can-cancel="false" :is-full-page="true" />

    <Header/>


    <div :class="styleMenu" v-if="menuDerecha">
      <ul class="sticky">
        <li>
          <div
            class="mt-4"
            @click="mostrarModalCrearHorario()"
            v-if="clinicaEstaSeleccionada && $localStorageService.can('BO_17_crearhor')"
          >
            <img alt="agenda" src="../assets/icons/cita-medica.png" width="32" height="32" />
            <p style="font-weight: 600">
              <a style="color: #0663a1" target="_blank"
                >Crear<br />
                horario <br/>
                doctores</a
              >
            </p>
          </div>
          <div class="mt-4" @click="mostrarModalCrearHorarioEspecialista()" v-if="$localStorageService.can('ICN_Horario_bloque')">
            <img alt="img" src="../assets/icons/cita-especialista.png" width="32" height="32" />
            <p style="font-weight: 600">
              <a style="color: #0663a1" target="_blank">Crear<br />
                horario <br/>
                bloques</a>
            </p>
          </div>
        </li>
      </ul>
    </div>

    <b-card class="bCardAgenda">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span
            ><b-icon icon="file-earmark-check" aria-hidden="true"></b-icon
          ></span>
          <span>Horario doctores {{ datosBusqueda.clinica.nombre }}</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>AG_01_Dx</div>
        </b-col>
      </b-row>

    <div class="mt-2 col-md-12"></div>
    <b-row class="">
      <b-col cols="12">
        <b-card
          style="
            border-radius: 20px;
            box-shadow: 0px 6px 17px -4px rgba(0, 0, 0, 0.12);
          "
        >
          <b-row>
            <b-col cols="3  ">
              <b-row>
                <b-col cols="3">
                  <label>Clínica:</label>
          
                </b-col>
                <b-col cols="9">
                  <div>
                     <v-select
                      style="
                        width: 100%;
                        border: 2px solid;
                        border-color: #aceaf4;
                        border-radius: 8px;
                      "
                      :clearable="false" :options="listaClinicasFiltro"
                     v-model="datosBusqueda.clinica.clinicaID"
                     :reduce="(variable) => variable.id"
                     :filterable="false"
                     @search="filtroClinicas"
                     label="nombre" placeholder="Selecciona una clínica"
                     v-if="$localStorageService.can('CA_06_selec_clinica')"
                     @input="actualizarNombreClinica(false)"
                    >
                      <span slot="no-options"
                        >No hay clinicas disponibles</span
                      >
                    </v-select>
                  </div>
                </b-col>
              </b-row>
            </b-col>

            <b-col cols="6" align="center">
              <div class="selectWeek">
                <button
                  style="color: #1b81af"
                  aria-label="Previous week"
                  class="vuecal__arrow vuecal__arrow--prev"
                  v-on:click="cambiarAnteriorSemana()"
                >
                  &nbsp;<i class="angle"></i>&nbsp;
                </button>
                <span style="text-transform: uppercase">{{
                  semana.numeroSemana
                }}</span>
                <button
                  style="color: #1b81af"
                  aria-label="Next week"
                  class="vuecal__arrow vuecal__arrow--next"
                  v-on:click="cambiarSiguienteSemana()"
                >
                  &nbsp;<i class="angle"></i>&nbsp;
                </button>
              </div>
               <div class="w-50">
              <b-form-datepicker
                style="border: solid 1px #fff;"
              v-model="datosBusqueda.fechaActual"
              class="mb-2"
              in
              no-flip
              @click.native="seleccionarFechaCalendario"
            ></b-form-datepicker>
            </div>
            </b-col>

            <!--   <b-col cols="4" align="left">
              <b-button-group>
                <b-button
                  variant="outline-primary"
                  @click="
                    mostrarModalCrearCita(false);
                    second = true;
                    citaIsOverbooking = false;
                    menuDerecha = false;
                  "
                  v-if="
                    clinicaEstaSeleccionada &&
                    $localStorageService.can('CA_06_crear_cita')
                  "
                >
                  <b-icon icon="plus-circle"></b-icon>
                  Crear cita
                </b-button>
                <b-button
                  variant="outline-primary"
                  @click="activarModalOverbooking()"
                  v-if="clinicaEstaSeleccionada"
                >
                  <b-icon icon="search"></b-icon>
                  Overbooking
                </b-button>
                <b-button
                  variant="outline-primary"
                  @click="mostrarModalCrearCita(true)"
                  v-if="
                    clinicaEstaSeleccionada &&
                    $localStorageService.can('CA_06_crear_cita_embajador')
                  "
                >
                  <b-icon icon="plus-circle"></b-icon>
                  Crear cita embajador
                </b-button>

                <b-button variant="outline-primary" @click="buscarAgenda()">
                  <b-icon title="Refrescar" icon="arrow-repeat"></b-icon>
                </b-button>
              </b-button-group>
            </b-col> -->

            <b-col style="margin-left: -5%;" cols="3">
              <div class="d-flex justify-content-start">
                <b-button  variant="outline-info" @click="buscarHorarios()">
                  <em class="fa fa-refresh"></em>
                </b-button>
                <b-button variant="outline-info" class="ml-2" @click="menuDerecha = !menuDerecha">
                  <em class="fa fa-bars"></em>
                </b-button>
               </div>
              <div class="mt-3">
                <div class="d-flex justify-content-start">
                  <label>Especialidades:</label>
                </div>
                <div >
                  
                 <div class="d-flex justify-content-start">
                  <span class="EspecialidadesArray" :title="item.nombre" v-b-tooltip.hover v-for="item in listaEsp"
                            :key="item.id">
                          <span @click="idEspecialidadFiltro = item.id" class="color mginLeft5 pointerCss"
                                :style="`background-color: ${item.color}`" ></span>
                      </span>
                 </div>
                 
                </div>
              </div>
            
             
     
            </b-col>
          </b-row>
        </b-card>

        <div class="mt-2 col-md-12"></div>

     
      </b-col>
    </b-row>

      <b-row class="">

        <b-col cols="12">
          <b-row>
            <b-col cols="3">
              
            </b-col>

            <b-col cols="2" align="left">
              <!-- <b-button-group>
                <b-button variant="outline-primary" @click="mostrarModalCrearHorario()"
                          v-if="clinicaEstaSeleccionada && $localStorageService.can('BO_17_crearhor')">
                  <b-icon icon="plus-circle"></b-icon>
                  Crear horario
                </b-button>

                <b-button variant="outline-primary" @click="buscarHorarios()">
                  <b-icon title="Refrescar" icon="arrow-repeat"></b-icon>
                </b-button>
              </b-button-group> -->
            </b-col>

            <b-col cols="4">
              
            </b-col>

            <b-col cols="3">
             
            </b-col>

          </b-row>

          <div class="mt-2 col-md-12"></div>

          <b-row>
            <b-col>
              <cal-doctores
                  @seleccionarFecha="seleccionarFechaPorDiaSemana"
                  @consultarDetalle="consultarDetalle"
                  @mostrarLoader="mostrarLoader"
                  @activarDesactivarHorario="activarDesactivarHorario"
                  @bloquear="mostrarModalBloquear"
                  @desbloquear="desbloquear"
                  @reasignarDoctor="reasignarDoctor"
                  :idEspecialidadFiltro="idEspecialidadFiltro"
                  ref="calDoctores"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-modal v-model="showDetailBloque" size="xl" :title="'Actualizar rango de horario por bloque del doctor '+datosDetalle.nombreDoctor"
      scrollable
      v-if="clinicaEstaSeleccionada && datosDetalle.esAutomatico !== true">
        <span style="display: none">idAgendaEmpleado: {{datosDetalle.idAgendaEmpleado}}</span>
<form>
 <b-row>
   <b-col cols="6">
     <label>Fecha inicial</label>
     <b-form-datepicker
     dropright
         id="fecha-inicial"
         :min="fechaActual && minFecha"
         :max="maxFecha"
         :disabled="datosDetalle.fechaInicio == null ||datosDetalle.sillon == null"
         v-model="datosDetalle.fechaInicio"
         placeholder="Fecha"
     ></b-form-datepicker>
   </b-col>
   <b-col cols="6">
     <label>Fecha final</label>
     <b-form-datepicker
         dropright
         id="fecha-final"
         :min="datosDetalle.fechaInicio"
         :max="maxFecha"
         :disabled="datosDetalle.fechaInicio == null ||datosDetalle.sillon == null ||datosDetalle.fechaInicio == null"
         v-model="datosDetalle.fechaFin"
         placeholder="Fecha"
     ></b-form-datepicker>
   </b-col>
   <b-col cols="6">
     <b-form-group label="Sillon">
       <b-form-select
           v-model="datosDetalle.sillon"
           :options="sillonArray"
           @change="llenarDoctoresEmbajador(datosDetalle.sillon>99, datosDetalle.idEspecialidad)"
       ></b-form-select>
     </b-form-group>
   </b-col>
   <b-col cols="6">
     <b-form-group label="Periodicidad">
       <b-form-radio
           v-model="datosDetalle.periodicidad"
           name="some-radios"
           value="5"
       >Único
       </b-form-radio>
       <b-form-radio
           v-model="datosDetalle.periodicidad"
           name="some-radios"
           value="1"
       >Semanal
       </b-form-radio>
       <b-form-radio
           v-model="datosDetalle.periodicidad"
           name="some-radios"
           value="2"
       >Quincenal
       </b-form-radio>
       <b-form-radio
           v-model="datosDetalle.periodicidad"
           name="some-radios"
           value="3"
       >Mensual
       </b-form-radio>
       <b-form-radio
           v-model="datosDetalle.periodicidad"
           name="some-radios"
           value="4"
       >Diario
       </b-form-radio>
     </b-form-group>
   </b-col>
   <b-col cols="6">
     <b-form-group label="Horario inicial">
       <b-form-select
           v-model="datosDetalle.horaInicio"
           :options="horaInicialArray"
           :disabled="datosDetalle.fechaInicio == null || datosDetalle.sillon == null"
           @change="transformArray(datosDetalle.horaInicio, 2)"
       ></b-form-select>
     </b-form-group>
   </b-col>
   <b-col cols="6">
    <b-form-group label="Bloque especialidad">
      <v-select
      v-model="datosDetalle.especialidad"
      :options="especialidadBloquesArray"
      :reduce="(variable) => variable.idBloque"
      label="especialidad"
      ></v-select>
    </b-form-group>
   </b-col>
   <b-col cols="6" >
    <b-form-group  label="Número de bloques">
    
    <b-form-input 
    @input="validarNumeroBloqueActualizar($event)"
    type="number"
    min="1"
    :max="limiteBloques"
    v-model="datosDetalle.numeroBloques"
    @keydown="decimalesKeydown($event)"
    @paste="onPaste"
></b-form-input>
  </b-form-group>
   </b-col>
   <b-col cols="6">
     <b-form-group label="Doctor">
       <b-form-select
           v-model="datosDetalle.idDoctor"
           :options="doctorArray"
           :disabled="datosDetalle.fechaInicio == null ||datosDetalle.sillon == null"
       ></b-form-select>
     </b-form-group>
   </b-col>
   <b-col cols="6">
     <b-form-group label="Activar / Inactivar Horario">
       <b-form-checkbox
           v-model="datosDetalle.registroActivo"
           switch
       ></b-form-checkbox>
     </b-form-group>
   </b-col>
 </b-row>
</form>

<div v-if="horarioOcupado !== undefined && horarioOcupado !== null">
 <b-alert variant="danger" show>HORARIO OCUPADO ORIGINAL</b-alert>
 <b-table striped hover :fields="encabezadosHorarioOcupado"  :items="horarioOcupado">
   <template #cell(horaInicial)="data">
     <b class="text-info">{{ data.value | formatoHoraDeEntero  }}</b>
   </template>

   <template #cell(horaFinal)="data">
     <b class="text-info">{{ data.value | formatoHoraDeEntero }}</b>
   </template>

   <template #cell()="data">
     <i>{{ data.value }}</i>
   </template>
 </b-table>
 <div class="mt-2 col-md-12"></div>
</div>

<div v-if="citasEnHorario !== undefined && citasEnHorario !== null && citasEnHorario.length > 0">
   <b-alert variant="danger" show>CITAS OCUPADAS EN HORARIO ORIGINAL</b-alert>
   <b-table striped hover :fields="encabezadosCitasEnHorario"  :items="citasEnHorario">
     <template #cell(horaInicio)="data">
       <b class="text-info">{{ data.value | formatoHoraDeEntero  }}</b>
     </template>

     <template #cell(horaFin)="data">
       <b class="text-info">{{ data.value | formatoHoraDeEntero }}</b>
     </template>

     <template #cell()="data">
       <i>{{ data.value }}</i>
     </template>
   </b-table>
 <div class="mt-2 col-md-12"></div>
</div>

<template v-slot:modal-footer>

 <b-button
     variant="outline-primary"
     size="sm"
     @click="actualizar(datosDetalle)"
     v-if="$localStorageService.can('BO_17_actualizar')"
     :disabled="
               loadingPut == true ||
               datosDetalle.sillon == null ||
               datosDetalle.fechaInicio == null ||
               datosDetalle.fechaFin == null ||
               datosDetalle.periodicidad == null ||
               datosDetalle.horaInicio == null ||
               datosDetalle.horaFin == null ||
               datosDetalle.idEspecialidad == null ||
               datosDetalle.idDoctor == null ||
               !horarioSillonValido
             ">Actualizar
 </b-button>
 <b-button variant="outline-danger" size="sm" @click="restaurarFormsBloque">Cancelar</b-button>
</template>

</b-modal>

    <b-modal v-model="showDetail" size="xl" :title="'Actualizar rango de horario del doctor '+datosDetalle.nombreDoctor+' por sillón y fecha de inicio en la clínica '+datosBusqueda.clinica.nombre"
             scrollable
             v-if="clinicaEstaSeleccionada && datosDetalle.esAutomatico !== true">
      <form>
        <b-row>
          <b-col cols="6">
            <label>Fecha inicial</label>
            <b-form-datepicker
            dropright
                id="fecha-inicial"
                :min="fechaActual && minFecha"
                :max="maxFecha"
                :disabled="datosDetalle.fechaInicio == null ||datosDetalle.sillon == null"
                v-model="datosDetalle.fechaInicio"
                placeholder="Fecha"
            ></b-form-datepicker>
          </b-col>
          <b-col cols="6">
            <label>Fecha final</label>
            <b-form-datepicker
                dropright
                id="fecha-final"
                :min="datosDetalle.fechaInicio"
                :max="maxFecha"
                :disabled="datosDetalle.fechaInicio == null ||datosDetalle.sillon == null ||datosDetalle.fechaInicio == null"
                v-model="datosDetalle.fechaFin"
                placeholder="Fecha"
            ></b-form-datepicker>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Sillon">
              <b-form-select
                  v-model="datosDetalle.sillon"
                  :options="sillonArray"
                  @change="llenarDoctoresEmbajador(datosDetalle.sillon>99, datosDetalle.idEspecialidad)"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Periodicidad">
              <b-form-radio
                  v-model="datosDetalle.periodicidad"
                  name="some-radios"
                  value="5"
              >Único
              </b-form-radio>
              <b-form-radio
                  v-model="datosDetalle.periodicidad"
                  name="some-radios"
                  value="1"
              >Semanal
              </b-form-radio>
              <b-form-radio
                  v-model="datosDetalle.periodicidad"
                  name="some-radios"
                  value="2"
              >Quincenal
              </b-form-radio>
              <b-form-radio
                  v-model="datosDetalle.periodicidad"
                  name="some-radios"
                  value="3"
              >Mensual
              </b-form-radio>
              <b-form-radio
                  v-model="datosDetalle.periodicidad"
                  name="some-radios"
                  value="4"
              >Diario
              </b-form-radio>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Horario inicial">
              <b-form-select
                  v-model="datosDetalle.horaInicio"
                  :options="horaInicialArray"
                  :disabled="datosDetalle.fechaInicio == null || datosDetalle.sillon == null"
                  @change="transformArray(datosDetalle.horaInicio, 2)"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Horario final">
              <b-form-select
                  v-model="datosDetalle.horaFin"
                  :options="horaFinalArray"
                  :disabled="datosDetalle.fechaInicio == null || datosDetalle.sillon == null"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="6" v-if="datosDetalle.sillon<100">
            <b-form-group label="Especialidad">
              <b-form-select
                  v-model="datosDetalle.idEspecialidad"
                  :options="especialidadArray"
                  :disabled="datosDetalle.fechaInicio == null || datosDetalle.sillon == null"
                  @change="llenarDoctores(datosBusqueda.clinica.clinicaID,datosDetalle.idEspecialidad)"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Doctor">
              <b-form-select
                  v-model="datosDetalle.idDoctor"
                  :options="doctorArray"
                  :disabled="datosDetalle.fechaInicio == null ||datosDetalle.sillon == null"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Activar / Inactivar Horario">
              <b-form-checkbox
                  v-model="datosDetalle.registroActivo"
                  switch
              ></b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <div v-if="horarioOcupado !== undefined && horarioOcupado !== null">
        <b-alert variant="danger" show>HORARIO OCUPADO ORIGINAL</b-alert>
        <b-table striped hover :fields="encabezadosHorarioOcupado"  :items="horarioOcupado">
          <template #cell(horaInicial)="data">
            <b class="text-info">{{ data.value | formatoHoraDeEntero  }}</b>
          </template>

          <template #cell(horaFinal)="data">
            <b class="text-info">{{ data.value | formatoHoraDeEntero }}</b>
          </template>

          <template #cell()="data">
            <i>{{ data.value }}</i>
          </template>
        </b-table>
        <div class="mt-2 col-md-12"></div>
      </div>

      <div v-if="citasEnHorario !== undefined && citasEnHorario !== null && citasEnHorario.length > 0">
          <b-alert variant="danger" show>CITAS OCUPADAS EN HORARIO ORIGINAL</b-alert>
          <b-table striped hover :fields="encabezadosCitasEnHorario"  :items="citasEnHorario">
            <template #cell(horaInicio)="data">
              <b class="text-info">{{ data.value | formatoHoraDeEntero  }}</b>
            </template>

            <template #cell(horaFin)="data">
              <b class="text-info">{{ data.value | formatoHoraDeEntero }}</b>
            </template>

            <template #cell()="data">
              <i>{{ data.value }}</i>
            </template>
          </b-table>
        <div class="mt-2 col-md-12"></div>
      </div>

      <template v-slot:modal-footer>
        <b-button
            variant="outline-primary"
            size="sm"
            @click="actualizar(datosDetalle)"
            v-if="$localStorageService.can('BO_17_actualizar')"
            :disabled="
                      loadingPut == true ||
                      datosDetalle.sillon == null ||
                      datosDetalle.fechaInicio == null ||
                      datosDetalle.fechaFin == null ||
                      datosDetalle.periodicidad == null ||
                      datosDetalle.horaInicio == null ||
                      datosDetalle.horaFin == null ||
                      datosDetalle.idEspecialidad == null ||
                      datosDetalle.idDoctor == null ||
                      !horarioSillonValido
                    ">Actualizar
        </b-button>
        <b-button variant="outline-danger" size="sm" @click="restaurarForms">Cancelar</b-button>
      </template>

    </b-modal>

    <b-modal v-model="modalAgregarHorario" size="xl" :title="'Agregar rango de horario doctor por sillón y fecha de inicio en la clínica '+datosBusqueda.clinica.nombre" no-close-on-backdrop>
      <ValidationObserver>
        <form novalidate>
          <div v-if="clinicaEstaSeleccionada">
            <b-row>
              <b-col cols="6">
                <label>Fecha inicial</label>
                <b-form-datepicker
                    id="fecha-inicial"
                    v-model="crearHorario.fechaInicial"
                    :min="fechaActual && minFecha"
                    :max="maxFecha"
                    placeholder="Fecha"
                    no-flip
                ></b-form-datepicker>
              </b-col>
              <b-col cols="6">
                <label>Fecha final</label>
                <b-form-datepicker
                    id="fecha-final"
                    no-flip
                    v-model="crearHorario.fechaFinal"
                    :min="crearHorario.fechaInicial"
                    :max="maxFecha"
                    :disabled="crearHorario.fechaInicial == null && crearHorario.sillon == null"
                    placeholder="Fecha"
                ></b-form-datepicker>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Sillon">
                  <b-form-select
                      v-model="crearHorario.sillon"
                      :options="sillonArray"
                      @change="llenarDoctoresEmbajador(crearHorario.sillon>99, crearHorario.especialidad)"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Periodicidad" v-slot="{ ariaDescribedby }">
                  <b-form-radio
                      v-model="crearHorario.periodicidad"
                      name="some-radios"
                      value="5"
                      :aria-describedby="ariaDescribedby"
                  >Único
                  </b-form-radio>
                  <b-form-radio
                      v-model="crearHorario.periodicidad"
                      name="some-radios"
                      value="1"
                      :aria-describedby="ariaDescribedby"
                  >Semanal
                  </b-form-radio>
                  <b-form-radio
                      v-model="crearHorario.periodicidad"
                      name="some-radios"
                      value="2"
                      :aria-describedby="ariaDescribedby"
                  >Quincenal
                  </b-form-radio>
                  <b-form-radio
                      v-model="crearHorario.periodicidad"
                      name="some-radios"
                      value="3"
                      :aria-describedby="ariaDescribedby"
                  >Mensual
                  </b-form-radio>
                  <b-form-radio
                      v-model="crearHorario.periodicidad"
                      name="some-radios"
                      value="4"
                      :aria-describedby="ariaDescribedby"
                  >Diario
                  </b-form-radio>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Horario inicial">
                  <b-form-select
                      v-model="crearHorario.horaInicial"
                      :options="horaInicialArray"
                      :disabled="crearHorario.fechaInicial == null || crearHorario.sillon == null"
                      @change="transformArray(crearHorario.horaInicial, 1)"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Horario final">
                  <b-form-select
                      v-model="crearHorario.horaFinal"
                      :disabled="crearHorario.fechaInicial == null || crearHorario.sillon == null"
                      :options="horaFinalArray"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6" v-if="crearHorario.sillon<100">
                <b-form-group label="Especialidad">
                  <b-form-select
                      v-model="crearHorario.especialidad"
                      :options="especialidadArray"
                      @change="llenarDoctores(datosBusqueda.clinica.clinicaID,crearHorario.especialidad)"
                      :disabled="crearHorario.fechaInicial == null || crearHorario.sillon == null"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Doctor">
                  <b-form-select
                      v-model="crearHorario.doctor"
                      :options="doctorArray"
                      :disabled="crearHorario.fechaInicial == null || crearHorario.sillon == null"
                  ></b-form-select>
                </b-form-group>
              </b-col>

            </b-row>
          </div>
        </form>
      </ValidationObserver>

      <div v-if="horarioOcupado !== undefined && horarioOcupado !== null">
        <b-alert variant="danger" show>HORARIO OCUPADO ORIGINAL</b-alert>
        <b-table striped hover :fields="encabezadosHorarioOcupado"  :items="horarioOcupado">
          <template #cell(horaInicial)="data">
            <b class="text-info">{{ data.value | formatoHoraDeEntero  }}</b>
          </template>

          <template #cell(horaFinal)="data">
            <b class="text-info">{{ data.value | formatoHoraDeEntero }}</b>
          </template>

          <template #cell()="data">
            <i>{{ data.value }}</i>
          </template>
        </b-table>
        <div class="mt-2 col-md-12"></div>
      </div>

      <template v-slot:modal-footer>

        <b-button
            variant="outline-primary"
            size="sm"
            @click="guardar(crearHorario)"
            v-if="$localStorageService.can('BO_17_guardar')"
            :disabled="
                            loadingPost == true ||
                            crearHorario.sillon == null ||
                            crearHorario.fechaInicial == null ||
                            crearHorario.fechaFinal == null ||
                            crearHorario.periodicidad == null ||
                            crearHorario.horaInicial == null ||
                            crearHorario.horaFinal == null ||
                            crearHorario.especialidad == null ||
                            crearHorario.doctor == null ||
                            !horarioSillonValido
                          ">Guardar
        </b-button>
        <b-button variant="outline-danger" size="sm" @click="modalAgregarHorario = false; menuDerecha = true;">Cancelar</b-button>

      </template>

    </b-modal>

    <b-modal v-model="modalAgregarHorarioEspecialista" size="xl" title="Horario especialista "  no-close-on-backdrop>
      <p>Configure un nuevo rango de horario especialista por bloque en la clínica {{datosBusqueda.clinica.nombre}}</p>
      <ValidationObserver>
        <form novalidate>
          <div v-if="clinicaEstaSeleccionada">
            <b-row>
              <b-col cols="6">
                <label>Fecha inicial</label>
                <b-form-datepicker
                    id="fecha-inicial"
                    v-model="crearHorario.fechaInicial"
                    :min="fechaActual && minFecha"
                    :max="maxFecha"
                    placeholder="Fecha"
                    no-flip
                ></b-form-datepicker>
              </b-col>
              <b-col cols="6">
                <label>Fecha final</label>
                <b-form-datepicker
                    id="fecha-final"
                    no-flip
                    v-model="crearHorario.fechaFinal"
                    :min="crearHorario.fechaInicial"
                    :max="maxFecha"
                    :disabled="crearHorario.fechaInicial == null && crearHorario.sillon == null"
                    placeholder="Fecha"
                ></b-form-datepicker>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Sillon">
                  <b-form-select
                      v-model="crearHorario.sillon"
                      :options="sillonArray"
                      @change="llenarDoctoresEmbajador(crearHorario.sillon>99, crearHorario.especialidad)"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Periodicidad" v-slot="{ ariaDescribedby }">
                  <b-form-radio
                      v-model="crearHorario.periodicidad"
                      name="some-radios"
                      value="5"
                      :aria-describedby="ariaDescribedby"
                  >Único
                  </b-form-radio>
                  <b-form-radio
                      v-model="crearHorario.periodicidad"
                      name="some-radios"
                      value="1"
                      :aria-describedby="ariaDescribedby"
                  >Semanal
                  </b-form-radio>
                  <b-form-radio
                      v-model="crearHorario.periodicidad"
                      name="some-radios"
                      value="2"
                      :aria-describedby="ariaDescribedby"
                  >Quincenal
                  </b-form-radio>
                  <b-form-radio
                      v-model="crearHorario.periodicidad"
                      name="some-radios"
                      value="3"
                      :aria-describedby="ariaDescribedby"
                  >Mensual
                  </b-form-radio>
                  <b-form-radio
                      v-model="crearHorario.periodicidad"
                      name="some-radios"
                      value="4"
                      :aria-describedby="ariaDescribedby"
                  >Diario
                  </b-form-radio>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Hora inicio">
                  <b-form-select
                      v-model="crearHorario.horaInicial"
                      :options="horaInicialArray"
                      :disabled="crearHorario.fechaInicial == null || crearHorario.sillon == null"
                      @change="transformArray(crearHorario.horaInicial, 1)"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6" v-if="crearHorario.sillon<100">
                <b-form-group label="Bloque especialidad">
                  <v-select
                  v-model="crearHorario.especialidad"
                  :options="especialidadBloquesArray"
                  :reduce="(variable) => variable.idBloque"
                  label="especialidad"
                  :disabled="crearHorario.fechaInicial == null || crearHorario.sillon == null"
                  ></v-select>
                </b-form-group>
              </b-col>
              
              <b-col cols="6">
                <b-form-group  label="Número de bloques">
                  <b-form-input 
                  @input="validarNumeroBloque($event)"
                  v-model="crearHorario.numeroBloques"
                  type="number"
                  min="1"
                  :max="limiteBloques"
                  :disabled="crearHorario.fechaInicial == null || crearHorario.sillon == null"
                  @keydown="decimalesKeydown($event)" 
                        @paste="onPaste"
    ></b-form-input>
       
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Doctor">
                  <b-form-select
                      v-model="crearHorario.doctor"
                      :options="doctorArray"
                      :disabled="crearHorario.fechaInicial == null || crearHorario.sillon == null"
                  ></b-form-select>
                </b-form-group>
              </b-col>

            </b-row>
          </div>
        </form>
      </ValidationObserver>

      <div v-if="horarioOcupado !== undefined && horarioOcupado !== null">
        <b-alert variant="danger" show>HORARIO OCUPADO ORIGINAL</b-alert>
        <b-table striped hover :fields="encabezadosHorarioOcupado"  :items="horarioOcupado">
          <template #cell(horaInicial)="data">
            <b class="text-info">{{ data.value | formatoHoraDeEntero  }}</b>
          </template>

          <template #cell(horaFinal)="data">
            <b class="text-info">{{ data.value | formatoHoraDeEntero }}</b>
          </template>

          <template #cell()="data">
            <i>{{ data.value }}</i>
          </template>
        </b-table>
        <div class="mt-2 col-md-12"></div>
      </div>

      <template v-slot:modal-footer>

        <b-button
            variant="outline-info"
            size="sm"
            @click="guardarHorarioEspecialista(crearHorario)"
            
            >Guardar
            <!-- :disabled="
                            loadingPost == true ||
                            crearHorario.sillon == null ||
                            crearHorario.fechaInicial == null ||
                            crearHorario.fechaFinal == null ||
                            crearHorario.periodicidad == null ||
                            crearHorario.horaInicial == null ||
                            crearHorario.horaFinal == null ||
                            crearHorario.especialidad == null ||
                            crearHorario.doctor == null
                          " -->
        </b-button>
        <b-button variant="outline-danger" size="sm" @click="modalAgregarHorarioEspecialista = false; menuDerecha = true;">Cancelar</b-button>

      </template>

    </b-modal>

    <b-modal v-model="modalBloquear" size="xl" :title="'Bloquear Horario del doctor '+horarioBloqueo.nombreDoctor+' en la clínica '+datosBusqueda.clinica.nombre">
      <ValidationObserver>
        <form novalidate>

          <b-row>
            <b-col cols="6">
              <label>Fecha inicial</label>
              <b-form-datepicker
                  no-flip
                  id="fecha-inicial"
                  :min="horarioBloqueo.fechaInicio"
                  :max="horarioBloqueo.fechaFin"
                  v-model="horarioBloqueo.fechaInicioBloqueo"
                  @click.native="actualizarFechaFinalBloqueo()"
                  placeholder="Fecha"
              ></b-form-datepicker>
            </b-col>
            <b-col cols="6">
              <label>Fecha final</label>
              <b-form-datepicker
                  id="fecha-final"
                  no-flip
                  :min="horarioBloqueo.fechaInicioBloqueo"
                  :max="horarioBloqueo.fechaFin"
                  :disabled="horarioBloqueo.fechaInicioBloqueo === null"
                  v-model="horarioBloqueo.fechaFinBloqueo"
                  placeholder="Fecha"
              ></b-form-datepicker>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Horario inicial">
                <b-form-select
                    v-model="horarioBloqueo.horaInicioBloqueo"
                    :options="horaInicialArray"
                    :disabled="horarioBloqueo.fechaInicioBloqueo === null"
                    @change="transformArray(horarioBloqueo.horaInicioBloqueo, 4)"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Horario final">
                <b-form-select
                    v-model="horarioBloqueo.horaFinBloqueo"
                    :disabled="horarioBloqueo.fechaInicioBloqueo === null"
                    :options="horaFinalArray"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </form>
      </ValidationObserver>

      <template v-slot:modal-footer>

        <b-button
            variant="outline-primary"
            size="sm"
            @click="bloquear"
            v-if="$localStorageService.can('BO_17_bloquear')"
            :disabled="
                            loadingPost ||
                            horarioBloqueo.fechaInicioBloqueo === null ||
                            horarioBloqueo.fechaFinBloqueo === null ||
                            horarioBloqueo.horaInicioBloqueo === null ||
                            horarioBloqueo.horaFinBloqueo === null
                          ">Guardar
        </b-button>
        <b-button variant="outline-danger" size="sm" @click="modalBloquear = false">Cancelar</b-button>

      </template>

    </b-modal>

    <b-modal v-if="horarioReasignar !== undefined && horarioReasignar!==null" v-model="mostrarModalReasignar" size="xl"
             :title="'Reasignar todo el horario del doctor '+horarioReasignar.nombreDoctor+' en la clínica '+datosBusqueda.clinica.nombre">
    <ValidationObserver>
      <form novalidate>
        <b-row>
          <b-col cols="6">
            <label>Fecha inicial</label>
            <b-form-datepicker
                id="fecha-inicial"
                no-flip
                v-model="horarioReasignar.fechaInicio"
                placeholder="Fecha"
                disabled
            ></b-form-datepicker>
          </b-col>
          <b-col cols="6">
            <label>Fecha final</label>
            <b-form-datepicker
                id="fecha-final"
                no-flip
                v-model="horarioReasignar.fechaFin"
                placeholder="Fecha"
                disabled
            ></b-form-datepicker>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Horario inicial">
              <b-form-select
                  v-model="horarioReasignar.horaInicio"
                  :options="horaInicialArray"
                  disabled
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Horario final">
              <b-form-select
                  v-model="horarioReasignar.horaFin"
                  :options="horaFinalArray"
                  disabled
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Periodicidad" disabled>
              <b-form-radio
                  v-model="horarioReasignar.periodicidad"
                  name="some-radios"
                  value="5"
              >Único
              </b-form-radio>
              <b-form-radio
                  v-model="horarioReasignar.periodicidad"
                  name="some-radios"
                  value="1"
              >Semanal
              </b-form-radio>
              <b-form-radio
                  v-model="horarioReasignar.periodicidad"
                  name="some-radios"
                  value="2"
              >Quincenal
              </b-form-radio>
              <b-form-radio
                  v-model="horarioReasignar.periodicidad"
                  name="some-radios"
                  value="3"
              >Mensual
              </b-form-radio>
              <b-form-radio
                  v-model="horarioReasignar.periodicidad"
                  name="some-radios"
                  value="4"
              >Diario
              </b-form-radio>
            </b-form-group>
          </b-col>
          <b-col cols="6" v-if="horarioReasignar.sillon<100">
            <b-form-group label="Especialidad">
              <b-form-select
                  :disabled="horarioReasignar.idBloque !== null && horarioReasignar.idBloque !== undefined"
                  v-model="horarioReasignar.idEspecialidad"
                  :options="especialidadArray"
                  
                  @change="llenarDoctores(datosBusqueda.clinica.clinicaID, horarioReasignar.idEspecialidad)"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Doctor">
              <b-form-select
                  v-model="horarioReasignar.idDoctorAReasignar"
                  :options="doctorArray"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </ValidationObserver>

    <template v-slot:modal-footer>

      <b-button
          variant="outline-primary"
          size="sm"
          @click="submitReasignarDoctor"
          v-if="$localStorageService.can('CD_cambio_dr')"
          :disabled="
                            horarioReasignar.idDoctor === null ||
                            horarioBloqueo.idEspecialidad === null
                          ">Guardar
      </b-button>
      <b-button variant="outline-danger" size="sm" @click="mostrarModalReasignar = false">Cancelar</b-button>

    </template>

  </b-modal>

    </b-card>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
// import _ from "lodash";

export default {
  name: "agendaDoctores",
  components: {
    Header,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    limiteBloques: null,
    horaFin: {
      horaFin: null,
      horaFinTxt: null,
      minutosFinTxt: null,
      simbolo: ":"
    },
    styleMenu: "fade-in-right sticky-container",
    menuDerecha: true,
    loadingPost: false,
    loadingPut: false,
    loading: false,
    loadingCAl: false,
    loadingHorarios: false,
    semana: {},
    datosBusqueda: {
      clinica: {
        clinicaID: null,
        nombre: "-",
      },
      clinicaNombre: "-",
      fechaInicio: undefined,
      fechaFin: undefined,
      fechaActual: new Date(),
      empleadoId: null,
    },

    listaClinicas: [],
    listaClinicasFiltro: [],
    citasEnHorario: [],
    horarioOcupado: null,

    encabezadosCitasEnHorario: [
      {label: 'Cita', key: 'idCita', sortable: true, variant: 'danger'},
      {label: 'Paciente', key: 'nombrePaciente', sortable: true, variant: 'danger'},
      {label: 'Estatus', key: 'estatusCita', sortable: true, variant: 'danger'},
      {label: 'Sillon', key: 'sillon', sortable: true, variant: 'danger'},
      {label: 'Fecha', key: 'fechaCitaSinZona', sortable: true, variant: 'danger'},
      {label: 'Hora Inicio', key: 'horaInicio', sortable: true, variant: 'danger'},
      {label: 'Hora Fin', key: 'horaFin', sortable: true, variant: 'danger'}
    ],

    encabezadosHorarioOcupado: [
      {label: 'Agenda', key: 'idAgendaEmpleado', sortable: true, variant: 'danger'},
      {label: 'Doctor', key: 'nombreEmpleado', sortable: true, variant: 'danger'},
      {label: 'Sillon', key: 'sillon', sortable: true, variant: 'danger'},
      {label: 'Fecha inicio', key: 'fechaInicialSinFormato', sortable: true, variant: 'danger'},
      {label: 'Fecha fin', key: 'fechaFinalSinFormato', sortable: true, variant: 'danger'},
      {label: 'Hora inicio', key: 'horaInicial', sortable: true, variant: 'danger'},
      {label: 'Hora fin', key: 'horaFinal', sortable: true, variant: 'danger'},
      {label: 'Periodicidad', key: 'nombrePeriodicidad', sortable: true, variant: 'danger'},
    ],

    eventos: [],
    /* modal detalles*/
    showDetail: false,
    showDetailBloque: false,
    datosDetalle: [],
    second: false,
    horaInicialArray: [],
    horaFinalArray: [],
    especialidadArray: [],
    doctorArray: [],
    sillonArray: [],
    crearHorario: {
      horaInicial: null,
      horaFinal: null,
      especialidad: null,
      doctor: null,
      fechaInicial: null,
      fechaFinal: null,
      periodicidad: null,
      sillon: null,
      dia: null,
      idClinica: null,
      numeroBloques: null,
    },
    diaSelected: null,
    diasArray: [
      {
        value: 1,
        text: "Lunes",
      },
      {
        value: 2,
        text: "Martes",
      },
      {
        value: 3,
        text: "Miércoles",
      },
      {
        value: 4,
        text: "Jueves",
      },
      {
        value: 5,
        text: "Viernes",
      },
      {
        value: 6,
        text: "Sábado",
      },
      {
        value: 7,
        text: "Domingo",
      },
    ],
    horariosClinicas: null,
    minFecha: null,
    maxFecha: null,
    modalAgregarHorario: false,
    modalAgregarHorarioEspecialista: false,

    modalBloquear: false,
    mostrarModalReasignar: false,
    horarioBloqueo: {},

    listaEsp: [],
    idEspecialidadFiltro: null,

    horarioReasignar: null,
    especialidadBloquesArray: [],
    horaFinalEspecialista: null,
    numeroBloquesModificar: null,
    horarioSillonValido: true,
  }),
  methods: {
    onPaste () {
     event.preventDefault()
 
    },
    decimalesKeydown(e) {
      if (['.','-','e'].includes(e.key)){
   e.preventDefault()
}
  },
    validarNumeroBloqueActualizar(val){
      this.datosDetalle.numeroBloques = val
      const result = this.especialidadBloquesArray.filter(bloque => bloque.idBloque == this.datosDetalle.especialidad);
    this.verificarDuracionHorario(this.datosDetalle, result[0], parseInt(val,10), true)
    },
    validarNumeroBloque(val){
      this.crearHorario.numeroBloques = val
      const result = this.especialidadBloquesArray.filter(bloque => bloque.idBloque == this.crearHorario.especialidad);
    this.verificarDuracionHorario(this.crearHorario, result[0], parseInt(val,10),false)
    },
    obtenerCatalogoBloques() {
        this.loader = true;
        const parametros = {idClinica: this.datosBusqueda.clinica.clinicaID};
        this.$http
          .post(this.$api + "comisionBloqueEspecialista/obtener", parametros)
          .then((respuesta) => {
            if (respuesta.data) {
              this.especialidadBloquesArray = respuesta.data.data;
              this.especialidadBloquesArray.forEach(element => {
                element.especialidad = element.especialidad + ' (' + element.duracionHoras + 'hrs)' 
              });
            }
          })
          .finally(() => {
            this.loader = false;
          });
      },
    obtenerSemana() {
      let fecha = new Date();
      fecha = new Date(this.datosBusqueda.fechaInicio.toISOString());
      const mesSemana = this.$moment(fecha.toISOString()).format("MMMM YYYY");
      this.semana.numeroSemana =
        "Semana " +
        this.$moment(fecha.toISOString()).week() +
        " (" +
        mesSemana.charAt(0).toUpperCase() +
        mesSemana.slice(1) +
        ")";
    },
    cambiarAnteriorSemana() {
      let fecha = new Date(this.datosBusqueda.fechaInicio);
      fecha.setDate(fecha.getDate() - 7);
      this.seleccionarFecha(fecha);
    },

    cambiarSiguienteSemana() {
      let fecha = new Date(this.datosBusqueda.fechaInicio);
      fecha.setDate(fecha.getDate() + 7);
      this.seleccionarFecha(fecha);
    },
    filtroClinicas(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.listaClinicasFiltro = this.listaClinicas.filter(em => {
        return em.nombre.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    transformArray(horaInicial, opcion) {
      if (opcion == 2) {
        this.datosDetalle.horaFin = null;
      } else if (opcion == 1) {
        this.crearHorario.horaFinal = null;
      } else if (opcion == 4) {
        this.horarioBloqueo.horaFinBloqueo = null;
      }

      this.horaFinalArray.forEach((element) => {
        if (horaInicial >= element.value) {
          element.disabled = true;
        } else {
          element.disabled = false;
        }
      });
    },
    restaurarForms() {
      this.horaFinalArray.forEach((element) => {
        element.disabled = false;
      });
      this.crearHorario = {
        horaInicial: null,
        horaFinal: null,
        especialidad: null,
        doctor: null,
        fechaInicial: null,
        fechaFinal: null,
        periodicidad: 1,
        sillon: null,
        dia: null,
        idClinica: null,
      };
      this.showDetail = false;
      this.second = false;
      this.menuDerecha = true;
    },
    restaurarFormsBloque(){
      this.horaFinalArray.forEach((element) => {
        element.disabled = false;
      });
      this.crearHorario = {
        horaInicial: null,
        horaFinal: null,
        especialidad: null,
        doctor: null,
        fechaInicial: null,
        fechaFinal: null,
        periodicidad: 1,
        sillon: null,
        dia: null,
        idClinica: null,
      };
      this.showDetailBloque = false;
      this.second = false;
      this.menuDerecha = true;
    },  
    llenarEspecialidades() {
      this.especialidadArray = [];

      const idClinica = this.datosBusqueda.clinica.clinicaID;
      if (idClinica !== undefined && idClinica !== null) {
        const parametros = {idClinica: idClinica}
        this.$http
            .post(this.$api + "catalogos/obtenerEspecialidadesConColorClinica", parametros)
            .then((response) => {
              if (response.status === 200) {
                var arrayRespuesta = response.data.data.map((it) => {
                  return {
                    value: it.id,
                    text: it.especialidad,
                    color: it.color,
                  };
                });
                this.especialidadArray = arrayRespuesta.filter(function (item) {
                  return item.value != 0;
                });
              }
            })
            .catch((error) => {
              console.error(error);
            });
      }
    },
    llenarClinicas() {
      this.$http
          .get(this.$api + "catalogos/listaClinicas")
          .then((response) => {
            if (response.status === 200) {
              this.listaClinicas = response.data.data
                  .map((it) => {
                    return {
                      id: it.idClinica,
                      nombre: it.strNombre,
                      numeroSillones: it.numeroSillones,
                    };
                  })
                  .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
              this.listaClinicasFiltro = this.listaClinicas;
              this.actualizarNombreClinica(true);
            }
          })
          .catch((error) => {
            console.error(error);
          })
      // .finally(() => {
      //   const idClinica = this.datosBusqueda.clinica.clinicaID;
      //   this.llenarDoctoresClinica(idClinica);
      //   this.llenarPacientesClinica();
      // });
    },

    verificarNumerosBloqueLimite(datos,bloque){
      let ultimoHorario = this.horaInicialArray.length - 1;
      let horarioClinica = this.horaInicialArray[ultimoHorario].value - this.horaInicialArray[0].value
      let hora=null;
      if (horarioClinica.toString().length == 3) {
        hora=  horarioClinica.toString().substring(0,1)
      }else{
         hora= horarioClinica.toString().substring(0,2)
      }
      
      let limiteBloques = hora / bloque.duracionHoras;
      this.limiteBloques = Math.trunc(limiteBloques);

    },
    verificarDuracionHorario(datos,bloque, numeroBloques, actualizar){
      let mult = bloque.duracionHoras * numeroBloques
      let hora= null;
      let minutos = null;
      
     if(actualizar){
       hora= datos.horaInicio.substring(0,2)
       minutos = datos.horaInicio.substring(2,4)
     }else{
      hora= datos.horaInicial.substring(0,2)
      minutos = datos.horaInicial.substring(2,4)
     }
      let suma =  parseInt(hora,10) + mult 
      const hora_final = parseInt(suma + minutos,10)
      /* const hora_fin = suma.toString() + ':' + minutos.toString(); */
      this.horaFin = {
        horaFin: hora_final,
        horaFinTxt: suma.toString(),
        minutosFinTxt: minutos.toString()
      };
      let ultimoHorario = this.horaInicialArray.length - 1;
      if (hora_final > this.horaInicialArray[ultimoHorario].value) {
        this.horaFinalEspecialista = null;
        this.crearHorario.numeroBloques = null
        this.numeroBloquesModificar = null

        this.$swal.fire({
            icon: "error",
            title: "La duración de los bloques no debe ser mayor al horario de cierre de clínica",
            text: "Por favor seleccione una cantidad de bloques menor"
          }).then(() => {
           
       });
      }else{
        if (actualizar) {
          this.datosDetalle.horaFin = hora_final;
        }else{
          this.horaFinalEspecialista = hora_final;
        }
        
      }
    },

    llenarEspecialistas(idClinica, idEspecialidad) {
      
      this.doctorArray = [];
      if (idEspecialidad === undefined || idEspecialidad === null) {
        return;
      }
      const parametros = {
        idClinica: idClinica,
        idEspecialidad: idEspecialidad
      }
      this.$http
          .post(
              this.$api +
              "diagnostico/hoja/listaEspecialistasClinicaAgendaDoc", parametros
          )
          .then((response) => {
            if (response.status === 200) {
              this.doctorArray = response.data.data
                  .map((it) => {
                    return {
                      value: it.idEmpleado,
                      text: (it.numeroEmpleado + " " + it.nombreEmpleado + " (" + (this.obtenerEspecialidadesDoctor(it)) + ")")
                    };
                  })
                  .filter(
                      (v, i, a) => a.findIndex((t) => t.value === v.value) === i
                  );
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },
    llenarDoctores(idClinica, idEspecialidad) {
      
      this.doctorArray = [];
      if (idEspecialidad === undefined || idEspecialidad === null) {
        return;
      }
      const parametros = {
        idClinica: idClinica,
        idEspecialidad: idEspecialidad
      }
      this.$http
          .post(
              this.$api +
              "diagnostico/hoja/listaDoctoresClinicaAgendaDoc", parametros
          )
          .then((response) => {
            if (response.status === 200) {
              this.doctorArray = response.data.data
                  .map((it) => {
                    return {
                      value: it.idEmpleado,
                      text: (it.numeroEmpleado + " " + it.nombreEmpleado + " (" + (this.obtenerEspecialidadesDoctor(it)) + ")")
                    };
                  })
                  .filter(
                      (v, i, a) => a.findIndex((t) => t.value === v.value) === i
                  );
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },
    llenarDoctoresEmbajador(llenarHorarios, idEspecialidad) {
      this.doctorArray = [];
      if (!llenarHorarios) {
        this.llenarDoctores(this.datosBusqueda.clinica.clinicaID, idEspecialidad);
      } else {

        if (this.crearHorario !== undefined) {
          this.crearHorario.especialidad = 0;
        }

        if (this.datosDetalle !== undefined) {
          this.datosDetalle.especialidad = 0;
        }

        const parametros = {idClinica: this.datosBusqueda.clinica.clinicaID}
        this.$http
            .post(
                this.$api +
                "diagnostico/hoja/obtenerListaDoctoresEmbajadorClinica", parametros
            )
            .then((response) => {
              if (response.status === 200) {
                this.doctorArray = response.data.data
                    .map((it) => {
                      return {
                        value: it.idEmpleado,
                        text: (it.numeroEmpleado + " " + it.nombreEmpleado + " (" + (this.obtenerEspecialidadesDoctor(it)) + ")")
                      };
                    })
                    .filter(
                        (v, i, a) => a.findIndex((t) => t.value === v.value) === i
                    );
              }
            })
            .catch((error) => {
              console.error(error);
            });
      }
    },
    buscarHorarios() {

      this.eventos = Array();

      const idClinica = this.datosBusqueda.clinica.clinicaID;
      if (idClinica === undefined || idClinica === null || idClinica === 0) {
        return;
      }

      this.loading = true;
      this.loadingCAl = true;
      const clinicaID = this.datosBusqueda.clinica.clinicaID;
      const fechaInicio = this.$moment(this.datosBusqueda.fechaInicio).add(-1, 'days').utc().format('YYYY-MM-DD[T]HH:mm[:00Z]');
      // const fechaFin = "&fechaFin=" + this.$moment(this.datosBusqueda.fechaFin).utc().format('YYYY-MM-DD[T]HH:mm[:00Z]');

      const fechaInicioCalendario = this.$moment(this.datosBusqueda.fechaInicio);
      fechaInicioCalendario.set({hour:0,minute:0,second:0,millisecond:0})

      const fechaFinCalendario = fechaInicioCalendario.clone().add(7, 'days');
      fechaFinCalendario.set({hour:0,minute:0,second:0,millisecond:0})

      const parametros = {
        clinica: clinicaID,
        fechaInicio: fechaInicio
      }
      this.$http.post(this.$api + "horarioDoctores/obtener/horarios", parametros)
          .then((response) => {
            if (response.status === 200 && response.data.data !== undefined && response.data.data !== null) {

              response.data.data.forEach(v => {
                let fechaEvento = null;

                v.horaInicio = v.horaInicio.toString().substring(0,10);

                v.horaInicio = v.horaInicio.toString();
                if (v.horaInicio.length < 4) {
                  v.horaInicio = '0' + v.horaInicio;
                }

                v.horaFin = v.horaFin.toString();
                if (v.horaFin.length < 4) {
                  v.horaFin = '0' + v.horaFin;
                }

                if (v.horaInicio.toString().length === 4) {
                  v.horaInicioCasilla = v.horaInicio.substr(0, 2) + ':' + v.horaInicio.substr(2, 3);
                }
                if (v.horaFin.toString().length === 4) {
                  v.horaFinCasilla = v.horaFin.substr(0, 2) + ':' + v.horaFin.substr(2, 3);
                }

                if (!v.horarioBloqueado) {
                  v.fechaAgenda = v.fechaAgenda.toString().substring(0,10);
                  fechaEvento = this.$moment(v.fechaAgenda).format('YYYY/MM/DD');
                  this.agregarHorarioAListado(fechaEvento, v);
                } else {
                  fechaEvento = this.$moment(v.fechaInicio);
                  const fechaFinEvento = this.$moment(this.$moment(v.fechaFin).format('YYYY/MM/DD'));
                  fechaFinEvento.set({hour:0,minute:0,second:0,millisecond:0})


                  while (fechaEvento <= fechaFinEvento) {
                    if (fechaEvento >= fechaInicioCalendario && fechaEvento <= fechaFinCalendario) {
                      this.agregarHorarioAListado(fechaEvento.format('YYYY/MM/DD'), v);
                    }
                    fechaEvento = (fechaEvento.add(1, 'days'));
                  }

                }
              });


              const listaEspTmp = [{
                id: null,
                nombre: "Todos",
                color: "white"
              }];
              Object.values(this.eventos).forEach(evento => {
                  const especialidad = {
                    id: evento.idEspecialidad,
                    nombre: evento.nombreEspecialidad,
                    color: evento.colorEspecialidad
                  };
                if (especialidad !== undefined && especialidad !== null && especialidad.id !== undefined && especialidad.id !== null) {
                  listaEspTmp[evento.idEspecialidad] = especialidad;
                }
              });
              this.listaEsp = Object.values(listaEspTmp);

            }
          })
          .catch((error) => {
            this.loadingCAl = false;
            console.error("No hay datos" + error);
          })
          .finally(() => {
            this.loadingCAl = false;
            if (this.$refs.calDoctores !== undefined) {
              this.$refs.calDoctores.calcularSemana(this.datosBusqueda.fechaInicio, this.eventos, this.getNumeroSillonesClinica);
            }
            this.loading = false;
            this.obtenerSemana();
          });
    },
    obtenerHorariosParaCalcularHorario(fechaInicial, fechaFinal, sillon, periodicidad) {
      this.loadingHorarios = true;

      const params = {
        clinica: this.datosBusqueda.clinica.clinicaID,
        fechaInicio: this.$moment(fechaInicial).utc().format('YYYY-MM-DD[T]HH:mm[:00Z]')
      }
      this.$http
          .post(
              this.$api + "horario/sillon/obtenerHorarios", params)
          .then((response) => {
            if (Array.isArray(response.data.data) == true) {
              this.horariosClinicas = response.data.data;

              this.horariosClinicas.forEach(v => {
                v.horaInicio = v.horaInicio.toString();
                if (v.horaInicio.length < 4) {
                  v.horaInicio = '0' + v.horaInicio;
                }

                v.horaFin = v.horaFin.toString();
                if (v.horaFin.length < 4) {
                  v.horaFin = '0' + v.horaFin;
                }

                if (v.horaInicio.toString().length === 4) {
                  v.horaInicioCasilla = v.horaInicio.substr(0, 2) + ':' + v.horaInicio.substr(2, 3);
                }
                if (v.horaFin.toString().length === 4) {
                  v.horaFinCasilla = v.horaFin.substr(0, 2) + ':' + v.horaFin.substr(2, 3);
                }
              });
            }
          })
          .catch((error) => {
            console.error("No hay datos" + error);
            this.loadingHorarios = false;
          })
          .finally(() => {

            this.creadorHorarioConResultados(fechaInicial, fechaFinal, sillon, periodicidad);
          });
    },
    agregarHorarioAListado(fechaEvento, v) {
      let pos = fechaEvento + '-' + v.horaInicio + '-' + v.sillon + '-' + v.horarioBloqueado;

      if (v.periodicidad !== undefined && v.periodicidad === 5) {
        pos += '-5';
      }

      this.eventos[pos] = {
        fechaAgenda: v.fechaAgenda !== null && v.fechaAgenda !== undefined ? this.$moment(v.fechaAgenda)
            .format("YYYY-MM-DD"): null,
        horaInicio: v.horaInicio,
        horaFin: v.horaFin,
        horaInicioCasilla: v.horaInicioCasilla,
        horaFinCasilla: v.horaFinCasilla,
        sillon: v.sillon,
        idDoctor: v.idDoctor,
        periodicidad: v.periodicidad,
        especialidad: v.especialidad,
        color: v.colorEspecialidad,
        nombreDoctor: v.nombreDoctor,
        fechaInicio: v.fechaInicio,
        fechaFin: v.fechaFin,
        idEspecialidad: v.idEspecialidad,
        nombreEspecialidad: v.especialidad,
        colorEspecialidad: v.colorEspecialidad,
        idAgendaEmpleado: v.idAgendaEmpleado,
        dia: v.dia,
        registroActivo: true,

        idAgendaInactiva: v.idAgendaInactiva,
        horarioBloqueado: v.horarioBloqueado,
        idBloque: v.idBloque,
        numeroBloques: v.numeroBloques,
        esAutomatico: v.esAutomatico
      };
    },
    actualizarNombreClinica(inicializar) {
      this.llenarEspecialidades();
      if (this.listaClinicas !== undefined) {
        const clinicaSelec = this.listaClinicas.find(it => it.id === this.datosBusqueda.clinica.clinicaID);
        if (clinicaSelec !== undefined && clinicaSelec !== null) {
          this.datosBusqueda.clinica.nombre = clinicaSelec.nombre;

          if (inicializar) {
            const fechaActual = new Date();
            this.seleccionarFecha(fechaActual);
          } else {
            this.buscarHorarios();
          }

          // const idClinica = this.datosBusqueda.clinica.clinicaID;
          // this.llenarDoctoresClinica(idClinica);
          // this.llenarPacientesClinica();
        }
      }
    },
    seleccionarFechaPorDiaSemana(date) {

      this.datosBusqueda.fechaInicio = date;


      this.datosBusqueda.fechaFin = new Date();
      this.datosBusqueda.fechaFin.setDate(this.datosBusqueda.fechaInicio.getDate() + 7);
      this.buscarHorarios();
    },
    seleccionarFecha(date) {
      const fecha = new Date(date.toISOString());
      fecha.setHours(0);
      fecha.setMinutes(0);
      fecha.setMilliseconds(0);


      this.datosBusqueda.fechaInicio = new Date(fecha.toISOString());
      this.datosBusqueda.fechaInicio.setDate(fecha.getDate() - fecha.getDay());

      this.datosBusqueda.fechaFin = new Date(fecha.toISOString());
      this.datosBusqueda.fechaFin.setDate(fecha.getDate() + (7 - date.getDay()));

      this.buscarHorarios();
    },
    calcularNumeroSillones() {
      if (this.datosBusqueda.clinica !== null && this.datosBusqueda.clinica.clinicaID !== undefined && this.datosBusqueda.clinica.clinicaID > 0 && this.listaClinicas !== undefined && this.listaClinicas !== null) {
        const clinica = this.listaClinicas.find(c => c.id === this.datosBusqueda.clinica.clinicaID);
        if (clinica !== undefined) {
          const sillones = this.listaClinicas.find(c => c.id === this.datosBusqueda.clinica.clinicaID).numeroSillones;
          if (sillones !== undefined && sillones !== null && sillones > 0) {
            return sillones;
          }
        }
      }
      return 1;
    },
    creadorHorario(fechaInicial, fechaFinal, sillon, periodicidad) {
      this.obtenerHorariosParaCalcularHorario(fechaInicial, fechaFinal, sillon, periodicidad);
    },
    creadorHorarioConResultados(fechaInicial, fechaFinal, sillon, periodicidad) {


      const horariosPermitidos = [];
      this.horaInicialArray = [];
      this.horaFinalArray = [];
      this.minFecha = null;
      this.maxFecha = null;
      this.horarioSillonValido = true;

      if (fechaInicial !== null && this.horariosClinicas != null) {


        this.horariosClinicas.forEach((element) => {

          let diaElemento = element.dia;
          if (diaElemento > 6) { // cuando es domingo
            diaElemento = 0;
          }

          const fechaInicialReal = this.$moment(fechaInicial);
     
            if (diaElemento == fechaInicialReal.day() && element.sillon == sillon && element.sillonHabilitado === true) {
              const horaInicioCasilla = element.horaInicioCasilla ? element.horaInicioCasilla : "00:00";
              const horaFinCasilla = element.horaFinCasilla ? element.horaFinCasilla : "00:00";

              horariosPermitidos.push({"fecha": fechaInicialReal,"horaInicio": horaInicioCasilla, "horaFin": horaFinCasilla});
            }

          // }

        });
        // this.maxFecha = this.$moment(this.maxFecha);
      }

      // !Validador específico — siempre que fechaInicial, sillon y fechaFinal presentes,
      // independiente de si hay horarios para el día de inicio
      if (
        fechaInicial != null &&
        fechaFinal != null &&
        sillon != null
      ) {
        this.validarHorarioSillon(fechaInicial, fechaFinal, sillon, periodicidad);
      }
      if (horariosPermitidos.length > 0) {

        horariosPermitidos.sort((a,b) => (a.horaInicio > b.horaInicio) ? 1 : ((b.horaInicio > a.horaInicio) ? -1 : 0));

        horariosPermitidos.forEach(horarioP => {
          const day = this.$moment().format("YYYY-MM-DD");

          const dayIni = day + "T" + horarioP.horaInicio;
          const dayEnd = day + "T" + horarioP.horaFin;

          let hour = this.$moment(
              this.$moment(String(dayIni), "YYYY-MM-DD[T]HH:mm[:00Z]"),
              "HH,mm,ss"
          );
          const endHour = this.$moment(
              this.$moment(String(dayEnd), "YYYY-MM-DD[T]HH:mm[:00Z]"),
              "HH,mm,ss"
          );

          let range = [];

          // !hora inicial
          while (hour <= endHour) {
            range.push(this.$moment(hour.toDate()));
            hour = hour.clone().add(15, "m");
          }

          range.forEach((element) => {
            this.horaInicialArray.push({
              value: this.$moment(element).format("HHmm"),
              text: this.$moment(element).format("HH:mm"),
              disabled: false,
            });
          });

          let hourEnd = this.$moment(
              this.$moment(String(dayIni), "YYYY-MM-DD[T]HH:mm[:00Z]"),
              "HH,mm"
          ).add(15, "m");

          const endHourEnd = this.$moment(
              this.$moment(String(dayEnd), "YYYY-MM-DD[T]HH:mm[:00Z]"),
              "HH,mm"
          );

          let rangeEnd = [];

          while (hourEnd <= endHourEnd) {
            rangeEnd.push(this.$moment(hourEnd.toDate()));
            hourEnd = hourEnd.clone().add(15, "m");
          }

          rangeEnd.forEach((element) => {
            this.horaFinalArray.push({
              value: this.$moment(element).format("HHmm"),
              text: this.$moment(element).format("HH:mm"),
              disabled: false,
            });
          });

        });
      }

      this.loadingHorarios = false;
  },
  validarHorarioSillon(fechaInicial, fechaFinal, sillon, periodicidad) {
    this.horarioSillonValido = true;
    if (!Array.isArray(this.horariosClinicas)) return;

    const ini = this.$moment(fechaInicial);
    const fin = this.$moment(fechaFinal);
    const fail = (title, text) => {
      this.horarioSillonValido = false;
      this.$swal.fire({ icon: "warning", title, text });
    };

    const habilitados = this.horariosClinicas
      .filter(e => e.sillon == sillon && e.sillonHabilitado === true)
      .map(e => ({
        ini: this.$moment(e.fechaInicio).startOf('day'),
        fin: this.$moment(e.fechaFin).endOf('day'),
        dia: e.dia > 6 ? 0 : e.dia,
      }));

    if (habilitados.length === 0) {
      return fail("Sillón " + sillon + " sin configuración o deshabilitado",
        "No hay horarios habilitados para este sillón.");
    }

    const dentro = f => habilitados.some(r => f.isBetween(r.ini, r.fin, 'day', '[]'));
    if (!dentro(ini) || !dentro(fin)) {
      const minIni = this.$moment(Math.min(...habilitados.map(r => r.ini.valueOf())));
      const maxFin = this.$moment(Math.max(...habilitados.map(r => r.fin.valueOf())));
      return fail("Rango fuera de la configuración del sillón",
        "Sillón " + sillon + " habilitado entre " +
        minIni.format("YYYY-MM-DD") + " y " + maxFin.format("YYYY-MM-DD") + ".");
    }

    // Genera ocurrencias por periodicidad (5=Único,4=Diario,1=Sem,2=Quincenal,3=Mensual)
    const p = String(periodicidad);
    const dow = ini.day();
    const dom = ini.date();
    const matchOcurrencia = d => p === '5' ? d.isSame(ini, 'day')
      : p === '4' ? true
      : p === '3' ? d.date() === dom
      : p === '2' ? d.day() === dow && d.diff(ini, 'days') % 14 === 0
      : d.day() === dow;

    const sinCobertura = [];
    for (const c = ini.clone(); c.isSameOrBefore(fin, 'day'); c.add(1, 'day')) {
      if (!matchOcurrencia(c)) continue;
      const ok = habilitados.some(r => c.isBetween(r.ini, r.fin, 'day', '[]') && r.dia === c.day());
      if (!ok) sinCobertura.push(c.format("YYYY-MM-DD"));
    }

    if (sinCobertura.length > 0) {
      const lista = sinCobertura.length > 5
        ? sinCobertura.slice(0, 5).join(", ") + " y " + (sinCobertura.length - 5) + " más"
        : sinCobertura.join(", ");
      fail("Cobertura parcial del rango",
        "Sillón " + sillon + " no cubre " + sinCobertura.length + " día(s): " + lista + ".");
    }
  },
  consultarDetalle(horarioClinicaTmp) {
    this.menuDerecha = false;

    if (horarioClinicaTmp.esAutomatico === true) {
      this.$swal.fire({
        icon: "info",
        title: "Horario automático",
        text: "Este horario fue generado automáticamente y no se puede actualizar manualmente.",
      });
      this.menuDerecha = true;
      return;
    }

    if (horarioClinicaTmp.idBloque != null) {
      this.detalleHorarioBloque(horarioClinicaTmp);
    }else{
      this.detalleHorarioNormal(horarioClinicaTmp);
    }
  },

  detalleHorarioNormal(horarioClinicaTmp){
    const horarioClinica = JSON.parse(JSON.stringify(horarioClinicaTmp));
    this.transformArray(horarioClinica.horaInicio, 3);
    this.creadorHorario(horarioClinica.fechaInicio, horarioClinica.fechaFin, horarioClinica.sillon, horarioClinica.periodicidad);

    this.datosDetalle = horarioClinica;
    this.datosDetalle.numeroBloques = horarioClinica.numeroBloques

    if (this.datosDetalle.sillon < 100) {
      this.llenarDoctores(this.datosBusqueda.clinica.clinicaID, this.datosDetalle.idEspecialidad);
    } else {
      this.llenarDoctoresEmbajador(true, this.datosDetalle.idEspecialidad);
    }

    this.crearArraySillones(this.getNumeroSillonesClinica);

    this.showDetail = true;

    this.menuDerecha = false;
  },

  detalleHorarioBloque(horarioClinicaTmp) {

    const horarioClinica = JSON.parse(JSON.stringify(horarioClinicaTmp));
    const horarioClinicaOriginal = JSON.parse(JSON.stringify(horarioClinicaTmp));
    this.transformArray(horarioClinica.horaInicio, 3);
    this.creadorHorario(horarioClinica.fechaInicio, horarioClinica.fechaFin, horarioClinica.sillon, horarioClinica.periodicidad);

    this.datosDetalle = horarioClinica;
/*     

 */    
if (this.datosDetalle.numeroBloques == 0) {
  delete this.datosDetalle.numeroBloques;

}
this.numeroBloquesModificar = horarioClinicaOriginal.numeroBloques


    this.crearArraySillones(this.getNumeroSillonesClinica);
    const result = this.especialidadBloquesArray.filter(bloque => bloque.idBloque == horarioClinicaTmp.idBloque);
    this.llenarEspecialistas(this.datosBusqueda.clinica.clinicaID, result[0].idEspecialidad)  
    this.showDetailBloque = true;
    this.menuDerecha = false;
  },

  mostrarLoader(bandera) {
    this.loading = bandera;
  },

  /* Mostrar formulario para crear nuevo horario */
  mostrarModalCrearHorario() {
    if (
        this.datosBusqueda.empleadoId !== undefined &&
        this.datosBusqueda.empleadoId !== null
    ) {
      this.datosFormulario.idDoctor = this.datosBusqueda.clinica.empleadoId;
    }
    this.initDatosCitaNueva();

    this.crearArraySillones(this.getNumeroSillonesClinica);

    this.doctorArray = [];

    this.modalAgregarHorario = true;

    this.menuDerecha = false;
  },

  mostrarModalCrearHorarioEspecialista() {
    if (
        this.datosBusqueda.empleadoId !== undefined &&
        this.datosBusqueda.empleadoId !== null
    ) {
      this.datosFormulario.idDoctor = this.datosBusqueda.clinica.empleadoId;
    }
    this.initDatosCitaNueva();

    this.crearArraySillones(this.getNumeroSillonesClinica);

    this.doctorArray = [];

    this.modalAgregarHorarioEspecialista = true;

    this.menuDerecha = false;
  },

  initDatosCitaNueva() {
    this.restaurarForms();
    this.datosFormulario = {
      horaInicio: {HH: "07", mm: "00"},
      horaFin: {HH: "08", mm: "00"},
      comentario: null,
    };
  },
  crearArraySillones(sillon) {
    this.sillonArray = [];
    let i = 0;
    do {
      i += 1;
      this.sillonArray.push({value: i, text: i});
    } while (i < sillon);
    this.sillonArray.push({value: 100, text: '100 (E1)'});
    this.sillonArray.push({value: 101, text: '101 (E2)'});
  },
  actualizar(datos) {
    this.loadingPut = true;
    this.citasEnHorario = [];
    this.horarioOcupado = null;
    this.$http
        .put(this.$api + "horarioDoctores/actualizar/horario", {
          idAgendaEmpleado: datos.idAgendaEmpleado,
          idEmpleado: datos.idDoctor,
          dia: this.$moment(this.crearHorario.fechaInicio).day(),
          fechaInicial: this.$moment(datos.fechaInicio)
              .utc()
              .format("YYYY-MM-DD[T]HH:mm[:00Z]"),
          fechaFinal: this.$moment(datos.fechaFin)
              .utc()
              .format("YYYY-MM-DD[T]HH:mm[:00Z]"),
          horaInicial: datos.horaInicio,
          horaFinal: datos.horaFin,
          periodicidad: datos.periodicidad,
          sillon: datos.sillon,
          idUsuario: this.$localStorageService.getIdUsuario(),
          idEspecialidad: datos.idEspecialidad,
          idClinica: this.datosBusqueda.clinica.clinicaID,
          registroActivo: datos.registroActivo,
          numeroBloques: datos.numeroBloques,
          idBloque: datos.idBloque,
        })
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Se actualizó correctamente",
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.loadingPut = false;
            },
          });
          this.buscarHorarios();
          this.restaurarForms();
          this.showDetailBloque = false;
        })
        .catch((error) => {
          const message = error.response.data.message
              ? error.response.data.message
              : "Error al actualizar el horario";
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: message,
          }).then((result) => {
             if (result.isConfirmed) {
              this.loadingPut = false;
           }
       });

          this.horarioOcupado = [error.response.data.data.horarioOcupado];
          this.citasEnHorario = error.response.data.data.citasEnHorario;

          this.loadingPut = false;
        });
  },
  guardarHorarioEspecialista(datos){
    const result = this.especialidadBloquesArray.filter(bloque => bloque.idBloque == this.crearHorario.especialidad);
    this.loadingPost = true;
    datos.idClinica = this.datosBusqueda.clinica.clinicaID;
    this.citasEnHorario = [];
    this.horarioOcupado = null;
    if (this.crearHorario.numeroBloques == 0) {
      this.$swal.fire({
            icon: "error",
            title: "Número de bloques",
            text: "Debe haber por lo menos 1 número de bloques",
          }).then(() => {
       });
    }else if(this.horaFinalEspecialista == null){
      this.$swal.fire({
            icon: "error",
            title: "El horario del bloque no puede ser mayor a la hora de cierre de clínica y tampoco puede ir vacío",
            text: "Por favor seleccione un número de bloques menor",
          }).then(() => {
       });
    }else{
      
    this.$http
        .post(this.$api + "horarioDoctores/crear/horario", {
          dia: this.$moment(this.crearHorario.fechaInicial).day(),
          idEmpleado: datos.doctor,
          fechaInicial: this.$moment(datos.fechaInicial)
              .utc()
              .format("YYYY-MM-DD[T]HH:mm[:00Z]"),
          fechaFinal: this.$moment(datos.fechaFinal)
              .utc()
              .format("YYYY-MM-DD[T]HH:mm[:00Z]"),
          horaInicial: datos.horaInicial,
          horaFinal: this.horaFinalEspecialista,
          idClinica: datos.idClinica,
          idEspecialidad: result[0].idEspecialidad,
          idUsuario: this.$localStorageService.getIdUsuario(),
          periodicidad: datos.periodicidad,
          sillon: datos.sillon,
          idBloque: this.crearHorario.especialidad,
          numeroBloques: datos.numeroBloques
        })
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Se ingresó correctamente",
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.loadingPost = false;
              this.modalAgregarHorarioEspecialista = false;
            },
          });
          this.buscarHorarios();
          this.restaurarForms();
        })
        .catch((error) => {
          var message = error.response.data.message
              ? error.response.data.message
              : "Error al crear el horario";
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: message,
          }).then((result) => {
            if (result.isConfirmed) {
               this.loadingPost = false;
            }
          });

          this.horarioOcupado = [error.response.data.data.horarioOcupado];
        });
      }
      
  },
  guardar(datos) {
    this.loadingPost = true;
    datos.idClinica = this.datosBusqueda.clinica.clinicaID;
    this.citasEnHorario = [];
    this.horarioOcupado = null;
    this.$http
        .post(this.$api + "horarioDoctores/crear/horario", {
          dia: this.$moment(this.crearHorario.fechaInicial).day(),
          idEmpleado: datos.doctor,
          fechaInicial: this.$moment(datos.fechaInicial)
              .utc()
              .format("YYYY-MM-DD[T]HH:mm[:00Z]"),
          fechaFinal: this.$moment(datos.fechaFinal)
              .utc()
              .format("YYYY-MM-DD[T]HH:mm[:00Z]"),
          horaInicial: datos.horaInicial,
          horaFinal: datos.horaFinal,
          idClinica: datos.idClinica,
          idEspecialidad: datos.especialidad === undefined || datos.especialidad === null ? 0 : datos.especialidad,
          idUsuario: this.$localStorageService.getIdUsuario(),
          periodicidad: datos.periodicidad,
          sillon: datos.sillon,
        })
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Se ingresó correctamente",
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.loadingPost = false;
              this.modalAgregarHorario = false;
            },
          });
          this.buscarHorarios();
          this.restaurarForms();
        })
        .catch((error) => {
          var message = error.response.data.message
              ? error.response.data.message
              : "Error al crear el horario";
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: message,
          }).then((result) => {
            if (result.isConfirmed) {
               this.loadingPost = false;
            }
          });

          this.horarioOcupado = [error.response.data.data.horarioOcupado];
        });
  },
  activarDesactivarHorario(horario) {

    this.loadingPost = true;

    let mensaje = "Se activó correctamente el horario del doctor";
    let mensajeError = "Ocurrio un error al activar el horario";

    if (!horario.registroActivo) {
      mensaje = "Se desactivó correctamente el horario del doctor";
      mensajeError = "Ocurrio un error al desactivar el horario";
    }

    this.$swal({
      icon: "question",
      text: "¿Deseas desactivar el horario?",
      confirmButtonColor: "#0e6ba9",
      cancelButtonColor: "#8e8e8e",
      confirmButtonText: "Desactivar",
      cancelButtonText: "Cancelar",
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.$http
            .post(this.$api + "horarioDoctores/activarDesactivar", horario)
            .then(() => {
              this.$swal({
                icon: "success",
                title: mensaje,
                showConfirmButton: false,
                timer: 2500,
                onClose: () => {
                  this.loadingPost = false;
                },
              });
              this.buscarHorarios();
              this.restaurarForms();
            })
            .catch((error) => {
              var message = error.response.data.message
                  ? error.response.data.message
                  : mensajeError;
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: message,
              });
              this.loadingPost = false;
            });
      }
    });
  },

  mostrarModalBloquear(horarioBloqueo) {
    horarioBloqueo = JSON.parse(JSON.stringify(horarioBloqueo));
    horarioBloqueo.fechaInicioBloqueo = horarioBloqueo.fechaAgenda;
    horarioBloqueo.fechaFinBloqueo = horarioBloqueo.fechaAgenda;
    horarioBloqueo.horaInicioBloqueo = null;
    horarioBloqueo.horaFinBloqueo = null;
    this.horarioBloqueo = horarioBloqueo;

    this.creadorHorarioBloqueo();
    this.transformArray(this.horarioBloqueo.horaInicioBloqueo, 4);

    this.modalBloquear = true;
    this.loadingPost=false;
  },

  actualizarFechaFinalBloqueo() {
    this.horarioBloqueo.fechaFinBloqueo = this.horarioBloqueo.fechaInicioBloqueo;
  },

  creadorHorarioBloqueo() {

    // !hora inicial
    let horaInicio = this.$moment(this.horarioBloqueo.fechaAgenda + 'T' + this.horarioBloqueo.horaInicioCasilla);
    let horaInicioFin = this.$moment(this.horarioBloqueo.fechaAgenda + 'T' + this.horarioBloqueo.horaFinCasilla);


    let range = [];

    while (horaInicio <= horaInicioFin) {
      range.push(this.$moment(horaInicio.toDate()));
      horaInicio = horaInicio.clone().add(15, "m");
    }

    this.horaInicialArray = [];

    range.forEach((element) => {
      this.horaInicialArray.push({
        value: this.$moment(element).format("HHmm"),
        text: this.$moment(element).format("HH:mm"),
        disabled: false,
      });
    });

    // !hora final
    let horaFin = this.$moment(this.horarioBloqueo.fechaAgenda + 'T' + this.horarioBloqueo.horaInicioCasilla).add(15, "m");
    let horaFinFin = this.$moment(this.horarioBloqueo.fechaAgenda + 'T' + this.horarioBloqueo.horaFinCasilla);

    var rangeEnd = [];

    while (horaFin <= horaFinFin) {
      rangeEnd.push(this.$moment(horaFin.toDate()));
      horaFin = horaFin.clone().add(15, "m");
    }

    this.horaFinalArray = [];

    rangeEnd.forEach((element) => {
      this.horaFinalArray.push({
        value: this.$moment(element).format("HHmm"),
        text: this.$moment(element).format("HH:mm"),
        disabled: false,
      });
    });
  },

  bloquear() {

    const horarioBloqueo = JSON.parse(JSON.stringify(this.horarioBloqueo));
    horarioBloqueo.fechaInicioBloqueo = this.$moment(horarioBloqueo.fechaInicioBloqueo).utc().format("YYYY-MM-DD[T]HH:mm[:00Z]");
    horarioBloqueo.fechaFinBloqueo = this.$moment(horarioBloqueo.fechaFinBloqueo).utc().format("YYYY-MM-DD[T]HH:mm[:00Z]");

    this.$http
        .post(this.$api + "horarioDoctores/bloquearHorario", horarioBloqueo)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "El horario se bloqueo correctamente",
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.loadingPost = false;
            },
          });
          this.modalBloquear = false;
          this.buscarHorarios();
          this.restaurarForms();
        })
        .catch((error) => {
          const message = error.response.data.message
              ? error.response.data.message
              : "Ocurrio un error al realizar el bloqueo, intenta nuevamente";
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: message,
          });
          this.loadingPost = false;
        });
  },
  desbloquear(horarioBloqueo) {
    this.$swal({
      icon: "question",
      text: "¿Deseas desbloquear el horario?",
      confirmButtonColor: "#0e6ba9",
      cancelButtonColor: "#8e8e8e",
      confirmButtonText: "Desbloquear",
      cancelButtonText: "Cancelar",
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        const parametros = {
          idAgendaInactiva: horarioBloqueo.idAgendaInactiva,
        }
        this.$http
            .put(this.$api + "horarioDoctores/desbloquearHorario", parametros)
            .then((response) => {
              this.$swal({
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 2500,
                onClose: () => {
                  this.loadingPost = false;
                },
              });
              this.buscarHorarios();
              this.restaurarForms();
            })
            .catch((error) => {
              var message = error.response.data.message
                  ? error.response.data.message
                  : "Ocurrio un error al desactivar el bloqueo";
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: message,
              });
              this.loadingPost = false;
            });
      }
    });
  },
  obtenerEspecialidadesDoctor(doctor) {
    if (doctor.especialidades != undefined && doctor.especialidades !== null) {
      return doctor.especialidades.map(esp => esp.nombreEspecialidad).join(', ');
    } else {
      return '-';
    }
  },
  reasignarDoctor(horario) {
    this.horarioReasignar = horario;
    this.horarioReasignar.idDoctorAReasignar = horario.idDoctor;
    this.llenarEspecialidades();

    if (horario.idBloque != null) {
      const result = this.especialidadBloquesArray.filter(bloque => bloque.idBloque == horario.idBloque);
      this.llenarEspecialistas(this.datosBusqueda.clinica.clinicaID, result[0].idEspecialidad)  
    } else {
      this.llenarDoctores(this.datosBusqueda.clinica.clinicaID, horario.idEspecialidad);
    }

    this.mostrarModalReasignar = true;
  },
  submitReasignarDoctor() {

    if (this.horarioReasignar.idDoctor === this.horarioReasignar.idDoctorAReasignar) {
      this.$swal({
        icon: "info",
        text: "Para realizar la reasignación, selecciona un doctor diferente",
        confirmButtonText: "OK",
        confirmButtonColor: "#0e6ba9",
      })
      this.loading = false;
      return;
    }

    this.$swal({
      icon: "question",
      text: "Todas las citas de este doctor se reasignarán. ¿Deseas continuar?",
      confirmButtonColor: "#0e6ba9",
      cancelButtonColor: "#8e8e8e",
      confirmButtonText: "Aceptar",
      showCancelButton: true,
    }).then((aceptar) => {
      this.loading = true;
      if (aceptar.value) {
        this.$http
            .post(this.$api + "horarioDoctores/reasignarDoctor", {
              idAgendaEmpleado: this.horarioReasignar.idAgendaEmpleado,
              idDoctorAReasignar: this.horarioReasignar.idDoctorAReasignar
            })
            .then(() => {

              this.mostrarModalReasignar = false;
              this.loadingPost = false;

              this.buscarHorarios();
              this.restaurarForms();
              this.$swal({
                icon: "success",
                title: "El horario se reasigno correctamente",
                showConfirmButton: false,
                timer: 2500,
              });
            })
            .catch((error) => {
              const message = error.response.data.message
                  ? error.response.data.message
                  : "Ocurrió un error al realizar la reasignación, intenta nuevamente";
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: message,
              });
            }).finally(() => {
          this.loading = false;
          this.mostrarModalReasignar = false;
        });
      } else {
        this.loading = false;
      }
    });
  },
    seleccionarFechaCalendario() {
      this.seleccionarFecha(new Date(this.datosBusqueda.fechaActual));
    },
}
,

created()
{
  this.debug = this.$localStorageService.getDebug();

  if (this.$localStorageService.getIdEmpleado() !== undefined) {
    this.datosBusqueda.clinica.empleadoId = this.$localStorageService.getIdEmpleado();
  }
  if (this.$localStorageService.getIdClinica() !== undefined) {
    this.datosBusqueda.clinica.clinicaID = this.$localStorageService.getIdClinica();
  }

  this.fechaActual = new Date();
  this.llenarClinicas();
  this.llenarEspecialidades();
  this.obtenerCatalogoBloques();
}
,
watch: {
   "datosDetalle.numeroBloques": function (val) {
    const result = this.especialidadBloquesArray.filter(bloque => bloque.idBloque == this.datosDetalle.idBloque);
    this.verificarDuracionHorario(this.datosDetalle, result[0], parseInt(val,10), true)
  },
  "datosDetalle.especialidad": function (val) {
    this.datosDetalle.numeroBloques = 0;
    this.horaFinalEspecialista = null;
    const result = this.especialidadBloquesArray.filter(bloque => bloque.idBloque == val);
    this.verificarNumerosBloqueLimite(this.datosDetalle,result[0]);
    if (this.showDetailBloque) {
      this.llenarEspecialistas(this.datosBusqueda.clinica.clinicaID, result[0].idEspecialidad)  
    }
  }, 
  "crearHorario.numeroBloques": function (val) {
    const result = this.especialidadBloquesArray.filter(bloque => bloque.idBloque == this.crearHorario.especialidad);
    this.verificarDuracionHorario(this.crearHorario, result[0], parseInt(val,10),false)
  },
  "crearHorario.especialidad": function (val) {
    delete this.crearHorario.numeroBloques

    this.horaFinalEspecialista = null;
    const result = this.especialidadBloquesArray.filter(bloque => bloque.idBloque == val);
    this.verificarNumerosBloqueLimite(this.crearHorario,result[0]);
    if (this.modalAgregarHorarioEspecialista) {
      this.llenarEspecialistas(this.datosBusqueda.clinica.clinicaID, result[0].idEspecialidad)  
    }
    
  },
  "crearHorario.fechaInicial": function () {
    if (this.crearHorario.sillon != null && this.crearHorario.fechaInicial != null) {
      this.creadorHorario(this.crearHorario.fechaInicial, this.crearHorario.fechaFinal, this.crearHorario.sillon, this.crearHorario.periodicidad);
    }
  },
  "crearHorario.fechaFinal": function () {
        if (this.crearHorario.sillon != null && this.crearHorario.fechaInicial != null && this.crearHorario.fechaFinal != null) {
          this.creadorHorario(this.crearHorario.fechaInicial, this.crearHorario.fechaFinal, this.crearHorario.sillon, this.crearHorario.periodicidad);
        }
      },
  "crearHorario.sillon": function () {
    if (this.crearHorario.sillon != null && this.crearHorario.fechaInicial != null) {
      this.creadorHorario(this.crearHorario.fechaInicial, this.crearHorario.fechaFinal, this.crearHorario.sillon, this.crearHorario.periodicidad);
    }
  },
  "crearHorario.periodicidad": function () {
    if (this.crearHorario.sillon != null && this.crearHorario.fechaInicial != null) {
      this.creadorHorario(this.crearHorario.fechaInicial, this.crearHorario.fechaFinal, this.crearHorario.sillon, this.crearHorario.periodicidad);
    }
  },
  "datosDetalle.fechaInicio": function () {
    if (this.datosDetalle.sillon != null && this.datosDetalle.fechaInicio != null) {
      this.creadorHorario(this.datosDetalle.fechaInicio, this.datosDetalle.fechaFin, this.datosDetalle.sillon, this.datosDetalle.periodicidad);
    }
  },
  "datosDetalle.fechaFin": function () {
    if (this.datosDetalle.sillon != null && this.datosDetalle.fechaInicio != null && this.datosDetalle.fechaFin != null) {
      this.creadorHorario(this.datosDetalle.fechaInicio, this.datosDetalle.fechaFin, this.datosDetalle.sillon, this.datosDetalle.periodicidad);
    }
  },
  "datosDetalle.sillon": function () {
    if (this.datosDetalle.sillon != null && this.datosDetalle.fechaInicio != null) {
      this.creadorHorario(this.datosDetalle.fechaInicio, this.datosDetalle.fechaFin, this.datosDetalle.sillon, this.datosDetalle.periodicidad);
    }
  },
  "datosDetalle.periodicidad": function () {
    if (this.datosDetalle.sillon != null && this.datosDetalle.fechaInicio != null) {
      this.creadorHorario(this.datosDetalle.fechaInicio, this.datosDetalle.fechaFin, this.datosDetalle.sillon, this.datosDetalle.periodicidad);
    }
  },
},
computed: {
  clinicaEstaSeleccionada()
  {
    return (
        this.datosBusqueda.clinica.clinicaID !== undefined &&
        this.datosBusqueda.clinica.clinicaID !== null &&
        this.datosBusqueda.clinica.clinicaID > 0
    );
  }
,
  clinicaId()
  {
    return this.datosBusqueda.clinica.clinicaID;
  }
,
  getNumeroSillonesClinica: function () {
    return this.calcularNumeroSillones();
  },
}
,

}
;
</script>

<style scoped>
.animacionBoton:hover {background-color: #ededed}

.fade-in-bck {
  -webkit-animation: fade-in-bck 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation: fade-in-bck 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

@-webkit-keyframes fade-in-bck {
  0% {
    -webkit-transform: translateZ(80px);
    transform: translateZ(80px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}
@keyframes fade-in-bck {
  0% {
    -webkit-transform: translateZ(80px);
    transform: translateZ(80px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}

.scroll-area {
  position: relative;
  margin: auto;
  height: 300px;
}

.selectWeek {
  color: #1b81af;
  font-weight: 600;
  font-size: 25px;
}

.fade-out-right {
  -webkit-animation: fade-out-right 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: fade-out-right 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@-webkit-keyframes fade-out-right {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
}
@keyframes fade-out-right {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
}

.fade-in-right {
  -webkit-animation: fade-in-right 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation: fade-in-right 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

@-webkit-keyframes fade-in-right {
  0% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes fade-in-right {
  0% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

.slide-in-left {
  -webkit-animation: slide-in-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: slide-in-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@-webkit-keyframes slide-in-left {
  0% {
    -webkit-transform: translateX(-1000px);
    transform: translateX(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes slide-in-left {
  0% {
    -webkit-transform: translateX(-1000px);
    transform: translateX(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

.sticky-container {
  position: fixed;
  right: 0px;
  top: 50px;

  z-index: 1100;
}

.sticky li {
  border-radius: 20px 0px 0px 20px;
  box-shadow: -10px 11px 17px -6px rgba(0, 0, 0, 0.12);

  list-style-type: none;
  background-color: #fff;
  color: #efefef;
  height: 650px;
  padding: 10px;
  margin: 0px 0px 1px 0px;
}

.sticky li p {
  padding-top: 5px;
  margin: 0px;
  line-height: 16px;
  font-size: 11px;
}
.sticky li p a {
  text-decoration: none;
  color: #2c3539;
}
.sticky li p a:hover {
  text-decoration: underline;
}
.bCardAgenda {
  margin: 0.5%;
  padding: 0.5% 1% 0.5% 1%;
  border-radius: 20px;
}

.color {
  width: 16px;
  height: 16px;
  display: inline-block;
  margin-right: 16px;
  border: 1px solid #ddd !important;
}

.centrar {
  display: flex;
  justify-content: center;
}

.dropbtn {
  background-color: #3498db;
  color: white;
  padding: 16px;
  font-size: 16px;
  border: none;
}

.dropup {
  position: relative;
  display: inline-block;
}

.dropup-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 160px;
  bottom: 50px;
  z-index: 1;
}

.dropup-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropup-content a:hover {
  background-color: #ccc;
}

.dropup:hover .dropup-content {
  display: block;
}

.dropup:hover .dropbtn {
  background-color: #2980b9;
}
.inputPersonalizado:focus{
  box-shadow: 0px 0px 0px 3px rgba(191,222,255,1);
  border: 1px solid #80bdff;
  outline: none;
}
</style>
